import type React from "react";
import { useParams, Link } from "react-router-dom";
import { useDiary } from "@/hooks/useDiary";
import { formatDate } from "@/utils/date";

const DiaryDetailPage: React.FC = () => {
	const { diaryId } = useParams<{ diaryId: string }>();
	const { diary, loading, error } = useDiary(diaryId);

	if (loading) return <p>読み込み中...</p>;
	if (error) return <p>エラーが発生しました: {error.message}</p>;
	if (!diary) return <p>日記が見つかりません</p>;

	// 段落ごとにユニークなIDを生成する関数
	const generateParagraphId = (content: string, index: number) => {
		return `p-${content.substring(0, 10).replace(/\s/g, "-")}-${index}`;
	};

	return (
		<div className="container mx-auto px-4 py-8">
			<div className="flex justify-between items-center mb-6">
				<h1 className="text-3xl font-bold">日記詳細</h1>
				<Link
					to={`/diary/${diaryId}/edit`}
					className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
				>
					編集
				</Link>
			</div>

			<div className="bg-white p-6 rounded shadow">
				<h2 className="text-2xl font-semibold mb-2">{diary.title}</h2>
				<div className="flex justify-between items-center text-sm text-gray-500 mb-6">
					<span>作成日: {formatDate(diary.createdAt)}</span>
					<span>最終更新: {formatDate(diary.updatedAt)}</span>
				</div>
				1
				<div className="prose max-w-none">
					{diary.content
						.split("\n")
						.map(
							(paragraph, index) =>
								paragraph.trim() && (
									<p
										key={generateParagraphId(paragraph, index)}
										className="mb-4 last:mb-0"
									>
										{paragraph}
									</p>
								),
						)
						.filter(Boolean)}
				</div>
			</div>

			<div className="mt-6 flex justify-between">
				<Link to="/diary" className="text-blue-500 hover:underline">
					← 日記一覧に戻る
				</Link>
			</div>
		</div>
	);
};

export default DiaryDetailPage;
